export default __webpack_public_path__ + "images/2632f7d35595ba92c4edab46a02f0a02.svg";